module.exports = __webpack_public_path__ + "img/DiNapoli-3.228f4fdd.jpg";